import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Purchageprofile.css";
import { STATES } from "../../data/states";
import Swal from "sweetalert2";
import Edit from "../../myimgs/edit.png"
import Delete from "../../myimgs/delete.png"

const Purchageprofile = () => {
  const [agents, setAgents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    profileName: "",
    name: "",
    email: "",
    phoneNumber: "",
    address: "",
    state: "",
    city: "",
    zipCode: "",
    ssn: "",
  });

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const userId = localStorage.getItem("userId");

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Fetch profiles from API
  const fetchProfiles = async () => {
    try {
      setLoading(true);

      if (!userId) {
        console.error("User ID not found in localStorage");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `${baseUrl}/purchase-profile/user-id/${userId}`
      );

      if (response.data && response.data.data) {
        setAgents(response.data.data);
      } else {
        setAgents([]);
      }
    } catch (error) {
      console.error("Error fetching purchase profiles:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle Delete Purchase Profile
const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This action will permanently delete the purchase profile.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${baseUrl}/purchase-profile/delete/${id}`
        );

        if (response.data.status === 200 || response.status === 200) {
          Swal.fire({
            title: "Deleted!",
            text: "Purchase profile deleted successfully.",
            icon: "success",
            confirmButtonColor: "#3085d6",
          });
          fetchProfiles(); // Refresh the list
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Unable to delete the purchase profile.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error deleting profile:", error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while deleting.",
          icon: "error",
        });
      }
    }
  });
};


  useEffect(() => {
    fetchProfiles();
  }, []);

  // ✅ Handle Add / Edit submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      alert("User ID not found!");
      return;
    }

    const dataToSend = {
      ...formData,
      userId: Number(userId),
      id: isEditing ? editId : undefined,
    };

    try {
      const apiUrl = isEditing
        ? `${baseUrl}/purchase-profile/update`
        : `${baseUrl}/purchase-profile/add`;

      const response = await axios.post(apiUrl, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === 200) {
        Swal.fire({
          title: isEditing ? "Profile Updated!" : "Profile Added!",
          text: isEditing
            ? "Purchase profile updated successfully."
            : "Purchase profile added successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });

        toggleModal();
        fetchProfiles();

        // Reset form & edit state
        setFormData({
          profileName: "",
          name: "",
          email: "",
          phoneNumber: "",
          address: "",
          state: "",
          city: "",
          zipCode: "",
          ssn: "",
        });
        setIsEditing(false);
        setEditId(null);
      } else {
        alert("Failed to save purchase profile.");
      }
    } catch (error) {
      console.error("Error saving purchase profile:", error);
      alert("Something went wrong while saving profile.");
    }
  };

  // ✅ Handle Edit button click
  const handleEdit = (agent) => {
    setFormData({
      profileName: agent.profileName || "",
      name: agent.name || "",
      email: agent.email || "",
      phoneNumber: agent.phoneNumber || "",
      address: agent.address || "",
      state: agent.state || "",
      city: agent.city || "",
      zipCode: agent.zipCode || "",
      ssn: agent.ssn || "",
    });

    setEditId(agent.id);
    setIsEditing(true);
    setShowModal(true);
  };

  return (
    <div className="container">
      <div className="headersd">
        <h2>Purchase Profile</h2>
        <button
          className="add-agent-btn"
          onClick={() => {
            setIsEditing(false);
            setEditId(null);
            setFormData({
              profileName: "",
              name: "",
              email: "",
              phoneNumber: "",
              address: "",
              state: "",
              city: "",
              zipCode: "",
              ssn: "",
            });
            toggleModal();
          }}
        >
          + Add Profile
        </button>
      </div>

      {loading ? (
        <p className="loading-text">Loading profiles...</p>
      ) : (
        <table className="agents-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Name</th>
              <th>Email ID</th>
              <th>Phone No.</th>
              <th>Address</th>
              <th>State</th>
              <th>Zip Code</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
  {agents.length > 0 ? (
    agents.map((agent, index) => (
      <tr key={agent.id}>
        <td data-label="S. No.">{index + 1}</td>
        <td data-label="Name">{agent.name}</td>
        <td data-label="Email ID">{agent.email}</td>
        <td data-label="Phone No.">{agent.phoneNumber}</td>
        <td data-label="Address">{agent.address}</td>
        <td data-label="State">{agent.state}</td>
        <td data-label="Zip Code">{agent.zipCode}</td>
        <td data-label="Actions" className="btnjuis">
          <img src={Edit} alt="edit" onClick={() => handleEdit(agent)} />
          <img src={Delete} alt="delete" onClick={() => handleDelete(agent.id)} />
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>
        No profiles found
      </td>
    </tr>
  )}
</tbody>

        </table>
      )}

      {showModal && (
        <div className="modalpop-overlay">
          <div className="modalpop">
            <span
              className="close-button"
              onClick={() => {
                toggleModal();
                setIsEditing(false);
              }}
            >
              &times;
            </span>

            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="dipflx">
                <h2>
                  {isEditing ? "Edit Purchase Profile" : "My Purchase Profile"}
                </h2>
              </div>

              <input
                type="text"
                name="profileName"
                placeholder="Purchase Profile Name"
                value={formData.profileName}
                onChange={handleChange}
                required
              />

              <p className="info-text">
                As this profile information will be used to bind legal contact,
                please ensure to add information correctly. Missing or
                inaccurate information can cause the contract to be rejected.
              </p>

              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
                required
              />

              <div className="row">
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select State</option>
                  {STATES.map((state, index) => (
                    <option key={index} value={state}>
                      {state}
                    </option>
                  ))}
                </select>

                <input
                  type="text"
                  name="zipCode"
                  placeholder="Zip Code"
                  value={formData.zipCode}
                  onChange={handleChange}
                  required
                />
              </div>

              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
              />

              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />

              <button type="submit" className="save-button">
                {isEditing ? "SAVE CHANGES" : "SAVE PURCHASE PROFILE"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Purchageprofile;
